module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Expenditure to the Last Ditch")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "ch1sec1"
    }
  }, [_vm._v("MIGRANT MOTHER")]), _vm._v(" "), _c('p', {
    staticClass: "running_first_indent"
  }, [_vm._v("Dorothea Lange almost didn’t take her most famous photograph, "), _c('em', [_vm._v("Migrant Mother")]), _vm._v(". It was early March 1936, the end of a cold, miserable winter. Dorothea had been on the road for nearly a month photographing the desperate living and working conditions of migratory farm workers in California. She was worked out, weary to the bone. She’d packed up her cumbersome camera equipment and was driving north on Highway 101, thoughts of home filling her with relief. As she drove past Nipomo, California, a small handmade sign flashed by, “Pea Picker’s Camp.” She kept her foot on the gas pedal.")]), _vm._v(" "), _c('p', {
    staticClass: "running_text_indent"
  }, [_vm._v("A year earlier Dorothea had been to Nipomo on her first assignment for the government. She knew conditions for the migrant pea pickers were desperate. She drove on, arguing with herself, “Haven’t you plenty of negatives already on the subject? Isn’t this just one more of the same?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/21endnotes#ien3",
      "id": "en3"
    }
  }, [_vm._v("3")])]), _vm._v(" Twenty miles farther, almost without realizing what she was doing, she made a U-turn and headed back.")]), _vm._v(" "), _c('p', {
    staticClass: "running_text_indent"
  }, [_vm._v("Two weeks of sleet and steady rain had caused a rust blight, destroying the pea crop. There was no work, no money to buy food. Dorothea approached “the hungry and desperate mother,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/21endnotes#ien4",
      "id": "en4"
    }
  }, [_vm._v("4")])]), _vm._v(" huddled under a torn canvas tent with her children. The family had been living on frozen vegetables they’d gleaned from the fields and birds the children killed. Working quickly, Dorothea made just a few exposures, climbed back in her car, and drove home.")]), _vm._v(" "), _c('p', {
    staticClass: "running_text_indent"
  }, [_vm._v("Dorothea knew the starving pea pickers couldn’t wait for someone in Washington, DC to act. They needed help immediately. She developed the negatives of the stranded family, and rushed several photographs to the "), _c('em', [_vm._v("San Francisco News")]), _vm._v(". Two of her images accompanied an article on March 10th as the federal government rushed twenty thousand pounds of food to the migrants.")]), _vm._v(" "), _c('p', {
    staticClass: "running_text_indent"
  }, [_vm._v("The "), _c('em', [_vm._v("San Francisco News")]), _vm._v(" reported Dorothea happened by “chance” to be at Nipomo."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/21endnotes#ien5",
      "id": "en5"
    }
  }, [_vm._v("5")])]), _vm._v(" While it’s clearly important that Dorothea was heading up Highway 101 at just that moment, chance played only a small part. Carefully honed skills enabled her to “see” the photograph with her strong eye for composition, and a heart guided by compassion. Equally important was the personal drive that caused her to turn around on the highway and head back to the camp: her entire life, Dorothea would always ignore rough working conditions, pushing herself past exhaustion, past debilitating health problems. “You can’t deny what you must do, no matter what it costs. And with me it was always expenditure to the last ditch. I know the last ditch. I’ve lived on the last ditch.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/21endnotes#ien6",
      "id": "en6"
    }
  }, [_vm._v("6")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9e7c76e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07-chapter01.vue
// module id = 75
// module chunks = 0